module.exports = __webpack_public_path__ + "img/XtDesign.c090dfe6.svg";